var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RobiPromotion',{attrs:{"URL":"../images/4.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }